/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';

@Injectable({
  providedIn: 'root'
})
export class NavService {
  private navBar: MatSidenav;

  public setSidenav(navBar: MatSidenav) {
    this.navBar = navBar;
  }
  public open() {
    return this.navBar.open();
  }

  public close() {
    return this.navBar.close();
  }

  public toggle(): void {
    this.navBar.toggle();
  }
}
